import type { WizardTileConfig } from '../../types/tileConfig';

const TILE_CONFIGS: WizardTileConfig[] = [
  {
    label: 'offerWizard.stepWhichProduct.stromlieferung',
    value: 'stromlieferung',
    iconComponent: 'StromlieferungIcon',
    urlValue: 'Stromlieferung',
  },
  {
    label: 'offerWizard.stepWhichProduct.zertifikate',
    value: 'zertifikate',
    iconComponent: 'ZertifikateIcon',
    urlValue: 'Zertifikate',
  },
  {
    label: 'offerWizard.stepWhichProduct.direktvermarktung',
    value: 'direktvermarktung',
    iconComponent: 'DirektvermarktungIcon',
    urlValue: 'Vermarktung',
  },
  {
    label: 'offerWizard.stepWhichProduct.pvGrossanlage',
    value: 'pvGrossanlage',
    iconComponent: 'PVGrossanlageIcon',
    urlValue: 'Pvgrossanlage',
  },
  {
    label: 'offerWizard.stepWhichProduct.businessCharging',
    value: 'businessCharging',
    iconComponent: 'BusinessChargingIcon',
    urlValue: 'BusinessCharging',
  },
];

export default TILE_CONFIGS;
